






























import { allowedAny } from '@/store/interfaces/generic';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'ProfileMenu',
  props: {
    items: {
      required: true,
      type: Array as PropType<Array<allowedAny>>,
    },
  },
});
